module.exports = __webpack_public_path__ + "img/logo@2x.cb8e7eee.png";